import MiddleNavbar from "./MiddleNavbar";
import UpperNavbar from "./UpperNavbar";
import DownNavbar from "./DownNavbar";

export default function Navbar() {
  return (
    <div>
      <UpperNavbar />
      <MiddleNavbar />
      <DownNavbar />
    </div>
  );
}
